import Popup from "./Popup"
import Button from "./Button";
import Password from './Password';
import { useState } from "react";
const EditPassword = ({onClose, onAccept, user}) =>{
    const [password,setPassword] = useState()
    const [confirmPassword,setConfirmPassword] = useState()
    return(
         <div className="modal-overlay">
        <div className="confirm-modal">
        <div className="header1">{`Editar contraseña del usuario ${user.usuario}`}</div>
            <div className="invisible-horizontal-container">
                Nueva contraseña:
                <Password onChange={(d)=>setPassword(d)}></Password>
            </div>
            <div className="invisible-horizontal-container">
                Repetir contraseña:
                <Password onChange={(d)=>setConfirmPassword(d)}></Password>
            </div>
            <div className="invisible-horizontal-container">
            <Button text="Cancelar" onClick={()=>onClose()} color="#000000"></Button>
            <Button text='Actualizar'color="#61BAA5" onClick={()=>{
                if(!password || password.trim() === "" ){
                    alert('Introduzca una contraseña válida')
                } else {
                    if(confirmPassword!=password){
                        alert('Asegúrese de que las contraseñas coincidan')
                    } else {
                        onAccept(password)
                    }
                }
            }}></Button></div>
        
        </div>
        </div>
    )
}
export default EditPassword;